import React from 'react';
import clsx from 'clsx';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { OBannerFeature as OBannerFeatureComp } from '@marriott/mi-web-ui-kit';

const TEST_ID = 'designsystem-components-OBannerFeature';

export const OBannerFeatureConfig = {
  emptyLabel: 'OBannerFeature',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-banner-feature`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OBannerFeature = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div data-testid={TEST_ID} data-component-name={`o-${TEST_ID}`} id={componentId} className={clsx(styleclass)}>
      <EditableComponent config={OBannerFeatureConfig} {...props}>
        <OBannerFeatureComp {...props} />
      </EditableComponent>
    </div>
  );
};
